import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import GroupFormModal from "components/modals/group_form_modal";
import { createGroup, endEditGroups, updateGroups } from "../../store/actions/people";

export class PeopleGroupFormModal extends React.Component {
  static propTypes = {
    createGroup: PropTypes.func.isRequired,
    editingGroups: PropTypes.array,
    endEditGroups: PropTypes.func.isRequired,
    selectedPersonIds: PropTypes.array.isRequired,
    updateGroups: PropTypes.func.isRequired
  }

  isCreating() {
    const { editingGroups } = this.props;
    return editingGroups && editingGroups.length === 1 && !editingGroups[0].id;
  }

  handleGroupsEdit = (groups) => {
    this.props.updateGroups(groups);
  }

  handleGroupCreate = (groups) => {
    this.props.createGroup(groups[0], this.props.selectedPersonIds);
  }

  render() {
    return (
      <GroupFormModal
        groups={this.props.editingGroups}
        shown={this.props.editingGroups != null}
        onCancel={this.props.endEditGroups}
        onSubmit={this.isCreating() ? this.handleGroupCreate : this.handleGroupsEdit}
      />
    );
  }
}

const mapStateToProps = state => ({
  editingGroups: state.people.editingGroups,
  selectedPersonIds: state.selectList.selectedPersonIds,
});

const mapDispatchToProps = {
  createGroup,
  endEditGroups,
  updateGroups
};

export default connect(mapStateToProps, mapDispatchToProps)(PeopleGroupFormModal);
